import ApplicationConfig from '@/lib/application-config'
import moment from 'moment'
import connectHttpBase from './connect-http-base'

/**
 * ConnectGrowClient
 */
class ConnectGrowClient {
  endpoint(path) {
    return ApplicationConfig.getGrowServer() + path
  }

  getParams(parameters) {
    let apiKeyParam = { apikey: ApplicationConfig.getGrowApiKey(), pointType: 'Nearest' }
    const merged = { ...apiKeyParam, ...parameters }
    return { params: merged }
  }

  // 2024.01.24 OpenMeteo対応により廃止
  // @Deprecated
  getSoilMoisture(observation) {
    const timezone = moment.tz.guess()
    const now = moment()
      .subtract(3, 'hours')
      .format('YYYY/MM/DD/HH')
    const geohash = observation.geohash
    const drainage = observation.drainage
    const path = '/v1/weather/pf/' + geohash + '/' + now + '/' + timezone
    return connectHttpBase.getHttpClient().get(this.endpoint(path), this.getParams({ drainage }))
  }

  // 2024.01.24 OpenMeteo対応により廃止
  // @Deprecated
  getAccumulatedTemperature(observation) {
    const geohash = observation.geohash
    const baseDate = observation.startDate.replaceAll('-', '/')
    const zoneId = observation.zoneId
    const path = '/v1/weather/at/' + geohash + '/' + baseDate + '/' + zoneId
    let params = {}
    const targetDate = observation.endDate
    if (targetDate) {
      params.td = targetDate
    }
    params.llt = observation.lowerLimitTemperature
    return connectHttpBase.getHttpClient().get(this.endpoint(path), this.getParams(params))
  }

  // 2024.01.24 OpenMeteo対応により廃止
  // @Deprecated
  getWeatherInfo(latLon, startMomentUtc) {
    const path =
      '/v1/weather/info/' +
      latLon.latitude +
      '/' +
      latLon.longitude +
      '/' +
      startMomentUtc.format('YYYY/MM/DD/HH') +
      '/Etc/GMT'
    return connectHttpBase.getHttpClient().get(this.endpoint(path), this.getParams({}))
  }
}

const connectGrowClient = new ConnectGrowClient()
export default connectGrowClient
